module.exports = __webpack_public_path__ + "img/minimize.5a2d7706.svg";